import { createGlobalStyle, css } from "styled-components";
import { riotbarHeight } from "./rg-product-pages/mixins/dimensions";
import { SkinId } from "./types";
import { mixinSkins } from "./shared/mixins/themeStyles";
import tint from "polished/lib/color/tint";
import { bladeEdgesMixin, variableSpacersMixin } from "./shared/spacers";
const focus = (focusColor) => {
    return css `
    :focus {
      outline: none;
    }

    :focus-visible {
      outline: 2px solid ${focusColor};
    }

    @supports not selector(:focus-visible) {
      :focus {
        outline: 2px solid ${focusColor};
      }
    }
  `;
};
export const GlobalStyles = createGlobalStyle `

  #dialog-portal {
    position:absolute;
    top:0;
    left:0;
  }

  /* storybook canvas display modifications */
  .sb-show-main.sb-main-padded {
    padding: 0;
    background-color: "#fff";
    color:"#050505";
  }

  /* root responsive gutter variables */
  :root{
    ${variableSpacersMixin};
    ${bladeEdgesMixin}
    color-scheme: only light;
  }

  /* Adding scroll padding if fixed riotbar is present */
  body.riotbar-present {
    & * {
      scroll-margin-top: ${riotbarHeight}
    }


    margin-top: ${riotbarHeight} !important;
  }

  ${mixinSkins({
    [SkinId.Riot]: (chroma, paletteTokens) => css `
      body {
        background-color: ${paletteTokens.bladebg1};
        color: ${paletteTokens.bladetext1};

        &:visited,
        a:hover {
          color: ${paletteTokens.accents1};
        }
      }
      ${focus(paletteTokens.accents2)}
    `,
    [SkinId.RiotProduct]: (chroma, paletteTokens) => css `
      body {
        background-color: ${tint(0.05, paletteTokens.underlay)};
        color: ${paletteTokens.bladetext1};

        &:visited,
        a:hover {
          color: ${paletteTokens.accents1};
        }
      }
      ${focus(paletteTokens.accents2)}
    `,
    [SkinId.LeagueClient]: (chroma) => css `
      body {
        padding: 0;
        background-color: ${chroma.palette.almostBlack || "#000"};
        color: ${chroma.palette.gold2 || "#FFFFFF"};
      }

      * {
        user-select: none;
      }
    `,
})}
`;
//# sourceMappingURL=global-styles.js.map